module.exports = __webpack_public_path__ + "media/79.2e75bbfe.mp3";